

import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import { useTableColumnsPreventa } from '@/shared/hooks/useTableColumnsPreventa';
import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadoPreventaEnum, hasPermission, ROUTER_PATHS, TABLE_CONSTANTS,
} from '@/shared';
import { useNavigate } from 'react-router-dom';
import { Visibility } from '@mui/icons-material';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { fetchGetPreventasCorporativos } from '@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action';
import { IPreventaCorporativo } from '@/shared/interfaces/erp/preventa/preventa_corporativo.interface';
import { useState } from 'react';
// import { useUiStore } from '@/store/ui';
// import { AlertSeverityEnum } from '@/shared/interfaces';


interface TableCustomFilterPreventaFactibilidadProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  paramsFilter?: Partial<IPreventaCorporativo> & {[key: string]: any}
}

export default function TableCustomFilterPreventaFactibilidad({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  paramsFilter
}: TableCustomFilterPreventaFactibilidadProps) {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_factibilidadcoorporativa,
    PermissionsEnum.api_change_factibilidadcoorporativa
  ]);

  const navigate = useNavigate();
   const [rowSelection, setRowSelection] = useState({});
  // const setAlert = useUiStore(s => s.setAlert);

  ///* Hook
  const {
    columnsPreventaFactibilidadCorporativo
  } = useTableColumnsPreventa(paramsFilter?.estado_preventa as EstadoPreventaEnum);

  ///* Fetch


  ///* Hook

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: preventasRes,
    isRefetching
  } = fetchGetPreventasCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      ...paramsFilter
    }
  );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaCorporativo>
            columns={columnsPreventaFactibilidadCorporativo}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //activate check selector
            enableRowSelection
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            pinLeftColumnIndexes={[0,1,2]}
            enableSelectAll
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}

            customActionBtnSpace={(value) => {
              return (
                <>
                {
                  hasPermission(PermissionsEnum.api_view_preventacoorporativa)?
                    <Grid container>
                      <Grid item >
                        {
                          // (!value.aprueba_plan_personalizado && value.plan_personalizado && !value.plan)
                          // &&
                          // !!!value.prospecto_corporativo_data?.condicion_venta
                          // ?
                          // <Tooltip placement='top' title='En revisión...'>
                          //   <IconButton
                          //     onClick={() => {
                          //       setAlert(true, "El registro se encuentra es espera de aprobación por supervisor.", AlertSeverityEnum.info)
                          //     }}
                          //   >
                          //     <VisibilityOffIcon />
                          //   </IconButton>
                          // </Tooltip>
                          // :
                          // value.estado_preventa!=EstadoPreventaEnum.PREAPROBADA 
                          // || (value.estado_preventa==EstadoPreventaEnum.PREAPROBADA && value.preventa_aprobada_factibilidad)?
                            <Tooltip placement='top' title='Ver preventa'>
                              <IconButton
                                onClick={() => {
                                  navigate(`${ROUTER_PATHS.noc.preFactibilidadCorporativoView.replace(':idpreventacorporativa', value.id_preventa_coorporativa)}`);
                                  // navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/${value.id_preventa_coorporativa}`);
                                  // if(value.estado_preventa==EstadoPreventaEnum.EN_ESPERA || ( value.estado_preventa==EstadoPreventaEnum.PREAPROBADA && !value.preventa_aprobada_factibilidad) ){
                                  //   navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoAprobarNav}/${value.id_preventa_coorporativa}`);
                                  // }else{
                                  //   navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/${value.id_preventa_coorporativa}`);
                                  // }
                                  //navigate(`${ROUTER_PATHS.ventas.preventaCorporativoViewNav}/${value.id_preventa_coorporativa}/${value.prospecto_data.id_prospecto}`);
      
                                }}
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                            // :null
                            // <Tooltip placement='top' title='Cargándose Información...'>
                            //   <IconButton
                            //     onClick={() => {
                            //       setAlert(true, "El registro fue aprobado. Espere a que el vendedor complete la información necesaria.", AlertSeverityEnum.info)
                            //     }}
                            //   >
                            //     <VisibilityOffIcon />
                            //   </IconButton>
                            // </Tooltip>
                        }
                      </Grid>
  
                    </Grid>
                  :null
                }
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

    </>
  );


}

